import { Skeleton } from "@mui/material";
import MDAlert from "components/MDAlert";
import { JobPhase } from "generated/graphql";
import useGetJobWorkOrder from "hooks/jobs/useGetJobWorkOrder";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import { useParams } from "react-router";
import WorkOrderComponent from "./WorkOrderComponent";

export default function WorkOrder() {
  const { jobPhaseId } = useParams();
  const { loading, error, data } = useGetJobWorkOrder(jobPhaseId);
  return (
    <DashboardPage>
      {!loading && data && (
        <WorkOrderComponent data={data as JobPhase}>
          {loading && <Skeleton />}
          {error && <MDAlert>{error}</MDAlert>}
        </WorkOrderComponent>
      )}
    </DashboardPage>
  );
}
